export const ROW_ACTION_GROUPS = {
  BASIC: 0,
  MULTI_LANG: 1,
  ADVANCED: 2,
  ENTERPRISE: 3
};